
// Dimensions can also be any spotify image url filter properties
// See https://help.shopify.com/en/themes/liquid/filters/url-filters#img_url

export function resizeImage(imageURL: string, dimensions: string): string {
  // This Regex will match the extension (.png), which we then split() into a array
  const extensionRegex = /(\.[^/.]+$)/
  const [url, extensionAndQS]: string[] = imageURL.split(extensionRegex)
  return `${url}_${dimensions}${extensionAndQS}`
}
